import React, { Component } from "react";
import * as format from "../../../common/FormatFunctions";

import createEngine, {
  DefaultLinkModel,
  DefaultNodeModel,
  DiagramModel,
  DagreEngine,
  PathFindingLinkFactory
} from "@projectstorm/react-diagrams";
import { AutoDistribute } from "./Diagram";
import { CanvasWidget } from "@projectstorm/react-canvas-core";
import Diagram from "./Diagram";
import * as pr from "../../../common/PrimeComponents";

export class FlowItemListDiagram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      engine: null,
      model: null,
      subPartEngine: null,
      subPartModel: null,
      showSubPartFlow: false
    };
  }

  componentDidMount = () => {
    console.log(this.props.flowBean);
    if (this.state.engine === null) {
      var [engine, model, name] = this.renderDiagramEngine(this.props.flowBean);

      this.setState({ engine: engine, model: model, name: name });
    }
  };

  getComponentNodesForFlowItem = inputComponentList => {
    var componentNodes = [];
    var x = 25;
    var y = 25;
    inputComponentList.forEach(component => {
      var colourString = "";
      if (component.componentType === "PART") {
        colourString = "rgb(255,255,0)";
      } else {
        colourString = "rgb(128,255,0)";
      }
      var componentNode = new DefaultNodeModel({
        name: component.name,
        color: colourString
      });
      componentNode.registerListener({
        selectionChanged: e => {
          if (format.isNotNull(this.props.flowBean.fullFlowList)) {
            this.props.flowBean.fullFlowList.forEach(element => {
              if (element.entityId === component.id) {
                var [engine, model, name] = this.renderDiagramEngine(element);
                console.log("Setting Sub/Part Model...");
                this.setState({
                  name: name,
                  subPartEngine: engine,
                  subPartModel: model,
                  showSubPartFlow: true,
                  engine: null,
                  model: null
                });
              }
            });
          }
        }
      });
      componentNode.setPosition(x, y);
      //   componentNode.setLocked(true);
      x = x + 25;
      y = y + 25;
      componentNodes.push(componentNode);
    });

    return componentNodes;
  };
  createFlowItemNode = (flowItem, x, y) => {
    var node1 = new DefaultNodeModel({
      name: flowItem.name,
      color: "rgb(0,192,255)"
    });

    node1.registerListener({
      onClick: e => {
        console.log("CLICKED");
      }
    });
    node1.setPosition(x, y);
    //  node1.setLocked(true);
    return node1;
  };
  createOuputNode = (outputComponentList, x, y, name) => {
    var nameDisplay = "";
    console.log(outputComponentList);
    if (format.isNotNull(outputComponentList)) {
      outputComponentList.forEach(element => {
        console.log(element);
        nameDisplay = element.name;
      });
    }
    name = nameDisplay;
    var node1 = new DefaultNodeModel({
      name: nameDisplay,
      color: "rgb(128,0,128)"
    });

    node1.registerListener({
      onClick: e => {
        console.log("CLICKED");
      }
    });
    node1.setPosition(x, y);
    //  node1.setLocked(true);
    return node1;
  };

  linkComponentsToFlowItem = (componentNodes, flowItemINPort, model) => {
    componentNodes.forEach(element => {
      let port2 = element.addOutPort("");
      let link = port2.link(flowItemINPort);
      model.addAll(element, link);
    });

    return model;
  };

  renderDiagramEngine = flowBean => {
    // const dagreEngine = new DagreEngine({
    //   graph: {
    //     rankdir: "TB",
    //     ranker: "longest-path",
    //     marginx: 25,
    //     marginy: 25
    //   },
    //   includeLinks: true
    // });

    // 1) setup the diagram engine
    const engine = createEngine();

    var x = 100;
    var y = 50;
    var model = new DiagramModel();

    var name = "";
    if (format.isNotNull(flowBean)) {
      if (format.isNotNull(flowBean.flowItemList)) {
        var unlinkedPort = null;
        var length = flowBean.flowItemList.length;
        var counter = 1;
        flowBean.flowItemList.forEach(element => {
          console.log(element);

          //GATHER UP FLOW ITEM INPUT NODES
          var componentNodes = this.getComponentNodesForFlowItem(
            element.inputComponentList
          );

          //CREATE FLOW ITEM NODE
          var flowItemNode = this.createFlowItemNode(element, x, y);
          x = x + 100;
          y = y + 50;

          //ADD DEFAULT IN PORT
          let flowItemINPort = flowItemNode.addInPort("In");
          let flowItemOUTPort = flowItemNode.addOutPort("Out");
          //ADD ANY LINKS TO IN PORT HERE
          model = this.linkComponentsToFlowItem(
            componentNodes,
            flowItemINPort,
            model
          );
          //LINK FLOW ITEM AND INPUT COMPONENT NODES

          if (counter === length) {
            //FINAL FLOW ITEM , LINK TO PREVIOUS IF POSSIBLE
            if (unlinkedPort === null) {
              var outputNode = this.createOuputNode(
                element.outputComponentList,
                x,
                y,
                name
              );
              var finalInPort = outputNode.addInPort("");
              let finalLink = flowItemOUTPort.link(finalInPort);

              model.addAll(flowItemNode, outputNode, finalLink);
            } else {
              let link = unlinkedPort.link(flowItemINPort);
              var outputNode = this.createOuputNode(
                element.outputComponentList,
                x,
                y
              );
              var finalInPort = outputNode.addInPort("");
              let finalLink = flowItemOUTPort.link(finalInPort);

              model.addAll(flowItemNode, outputNode, finalLink, link);
            }
          } else {
            counter++;

            if (null === unlinkedPort) {
              unlinkedPort = flowItemOUTPort;

              model.addNode(flowItemNode);
            } else {
              let link = unlinkedPort.link(flowItemINPort);
              unlinkedPort = flowItemOUTPort;
              model.addAll(flowItemNode, link);
            }
          }
        });
      }
    }
    // node 1
    // const node1 = new DefaultNodeModel({
    //   name: "Flow Item 1",
    //   color: "rgb(0,192,255)"
    // });
    // node1.setPosition(100, 100);
    // let port1 = node1.addOutPort("Out");

    // // node 2
    // const node2 = new DefaultNodeModel({
    //   name: "Node 1",
    //   color: "rgb(0,192,255)"
    // });
    // node2.setPosition(100, 500);
    // let port2 = node2.addOutPort("Out");
    // // 5) link the ports
    // let link = port1.link(port2);

    // const model = new DiagramModel();
    // model.addAll(node1, node2, link);

    // 7) load model into engine
    engine.setModel(model);

    console.log(engine);
    console.log("This got this far, the render may be the issue");
    return [engine, model, name];
  };
  toggleView = () => {
    var [engine, model, name] = this.renderDiagramEngine(this.props.flowBean);

    this.setState({
      name: name,
      showSubPartFlow: false,
      subPartEngine: null,
      subPartModel: null,
      engine: engine,
      model: model
    });
  };

  render() {
    // if (!format.isNotNull(this.state.engine)) {
    //   return <React.Fragment>Loading...</React.Fragment>;
    // }

    return (
      <React.Fragment>
        <div
          style={{
            height: "100vh",
            width: "90vw",
            backgroundColor: "transparent"
          }}
        >
          <pr.Button
            icon="pi pi-arrow-left"
            style={
              this.state.subPartEngine === null
                ? { display: "none" }
                : { float: "right" }
            }
            onClick={this.toggleView}
          ></pr.Button>
          {this.state.engine != null && this.state.showSubPartFlow === false && (
            // <CanvasWidget
            //   className="srd-demo-canvas"
            //   style={{ height: "100%", width: "100%" }}
            //   engine={this.state.engine}
            // ></CanvasWidget>
            <AutoDistribute
              model={this.state.model}
              engine={this.state.engine}
            />
          )}
          {this.state.subPartEngine != null &&
            this.state.showSubPartFlow === true && (
              // <CanvasWidget
              //   className="srd-demo-canvas"
              //   style={{ height: "100%", width: "100%" }}
              //   engine={this.state.engine}
              // ></CanvasWidget>
              <AutoDistribute
                model={this.state.subPartModel}
                engine={this.state.subPartEngine}
                name={this.state.name}
              />
            )}
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Flows/UI/FlowItemListDiagram.js